
import React, { useCallback, useRef, useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

import useFetchClasses from "../../hooks/useFetchClasses";
import ModalCertificate from "./ModalCertificate";
import useFetchSections from "../../hooks/useFetchSections";
import { useLocation, useNavigate } from "react-router-dom";
import { ApiUrl } from "../../../ApiUrl";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import Select from "react-select";
import ReactPaginate from "react-paginate";

const AdmAttendanceEntry = () => {
  const todayDate = new Date().toISOString().split("T")[0];
  const formatDisplayDate = (value) => {
    if (!value) return "";

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
      return value;
    }

    return date.toLocaleDateString("en-CA");
  };

  const getCertificateType = (certificate) =>
    (certificate?.documentType || certificate?.document_type || "").toString();

  const getCertificateId = (certificate) =>
    certificate?.transfer_certificate_id || certificate?.id || "";

  const getSelectedStudentName = (studentDetails) =>
    [
      studentDetails?.first_name,
      studentDetails?.middle_name,
      studentDetails?.last_name,
    ]
      .filter(Boolean)
      .join(" ");

  const [formData, setFormData] = useState({
    document_no: "",
    school_admission_no: "",
    barcode: "",
    cancellationRemarks: "",
    cancelledOn: "",
    studentname: "",
    father_name: "",
    mother_name: "",
    nationality: "",
    category: "",
    date_of_admission: "",
    dob: "",
    classId: "",
    subjects_studied: "",
    total_working_day: "",
    total_present_day: "",
  });
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedDocumentType, setSelectedDocumentType] = useState(null);

  const [showStudentSelectionModal, setShowStudentSelectionModal] =
    useState(false);
  const dateToRef = useRef(null);
  const dateFromRef = useRef(null);
  const studentNameRef = useRef(null);
  const admissionNoRef = useRef(null);
  const barcodeRef = useRef(null);
  const { sections } = useFetchSections(formData.classId);
  const [message, setMessage] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 10; // adjust rows per page

  const handleClear = () => {
    // Reset input refs
    if (dateToRef.current) dateToRef.current.value = todayDate;
    if (dateFromRef.current) dateFromRef.current.value = todayDate;
    if (admissionNoRef.current) admissionNoRef.current.value = "";
    if (barcodeRef.current) barcodeRef.current.value = "";
    if (studentNameRef.current) studentNameRef.current.value = "";

    // Reset formData fields
    setFormData({
      document_no: "",
      school_admission_no: "",
      barcode: "",
      cancellationRemarks: "",
      cancelledOn: "",
      studentname: "",
      father_name: "",
      mother_name: "",
      nationality: "",
      category: "",
      date_of_admission: "",
      dob: "",
      classId: "",
      sectionId: "",
      subjects_studied: "",
      total_working_day: "",
      total_present_day: "",
    });

    // Reset React Selects
    setSelectedStatus(null);
    setSelectedDocumentType(null);
    setCurrentPage(0);

    // Clear localStorage (except critical keys)
    const keysToKeep = [
      "academicSessionId",
      "branchId",
      "nextAcademicSessionId",
      "orgId",
    ];
    const tempStorage = {};
    keysToKeep.forEach((key) => {
      const value = localStorage.getItem(key);
      if (value !== null) tempStorage[key] = value;
    });
    localStorage.clear();
    Object.entries(tempStorage).forEach(([key, value]) => {
      localStorage.setItem(key, value);
    });
  };
  useEffect(() => {
    if (dateFromRef.current && !dateFromRef.current.value) {
      dateFromRef.current.value = todayDate;
    }
    if (dateToRef.current && !dateToRef.current.value) {
      dateToRef.current.value = todayDate;
    }
  }, [todayDate]);

  const handleModalClose = () => {
    setShowStudentSelectionModal(false);
  };

  const { classes } = useFetchClasses();

  const [certificates, setCertificates] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const academicSessionId = localStorage.getItem("academicSessionId");
    const orgId = localStorage.getItem("orgId");
    const branchId = localStorage.getItem("branchId");

    const apiUrl = `${ApiUrl.apiurl}STUDENT_CERTIFICATE/GetStudentCertificates/?academic_year_id=${academicSessionId}&orgId=${orgId}&branchId=${branchId}`;

    const fetchCertificates = async () => {
      try {
        const response = await fetch(apiUrl);
        const result = await response.json();

        if (result.message === "success") {
          setCertificates(result.data);
        } else {
          console.error("Failed to fetch certificates:", result.message);
        }
      } catch (error) {
        console.error("Error fetching certificates:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCertificates();
  }, []);

  const handleClassChange = (e) => {
    const classId = e.target.value;

    if (classId) {
      localStorage.setItem("selectedCertificateClassId", classId);
    } else {
      localStorage.removeItem("selectedCertificateClassId");
    }

    setFormData((prev) => ({
      ...prev,
      classId,
      sectionId: "",
    }));

  };

  const handleSectionChange = (e) => {
    const sectionId = e.target.value;

    if (sectionId) {
      localStorage.setItem("selectedCertificateSectionId", sectionId);
    } else {
      localStorage.removeItem("selectedCertificateSectionId");
    }

    setFormData((prev) => ({ ...prev, sectionId }));
  };

  const handleSelectChange = (event) => {
    const selectedValue = event.target.value;

    if (selectedValue === "") {
      localStorage.removeItem("selectedDocumentType");
    } else {
      localStorage.setItem("selectedDocumentType", selectedValue);
    }
  };

  const navigate = useNavigate();
  const location = useLocation();

  const handleNewButtonClick = async () => {
    const studentName = studentNameRef.current?.value;
    const admittedClass = formData.classId;
    const admittedSection = formData.sectionId;
    const documentType = selectedDocumentType?.value;

    if (!studentName) {
      alert("Please enter or select a student name.");
      return;
    }
    if (!admittedClass) {
      alert("Please select an admitted class.");
      return;
    }
    if (!admittedSection) {
      alert("Please select an admitted section.");
      return;
    }
    if (!documentType) {
      alert("Please select a document type.");
      return;
    }

    const academicYearId = localStorage.getItem("academicSessionId");
    const orgId = localStorage.getItem("orgId");
    const branchId = localStorage.getItem("branchId");
    const studentId = localStorage.getItem("selectedCertificateStudentId");

    localStorage.removeItem("transfer_certificate_id");
    localStorage.setItem("documentType", documentType);
    localStorage.setItem("document_type", documentType);
    localStorage.setItem("studentId", studentId || "");

    try {
      const apiUrl = `${ApiUrl.apiurl}STUDENT_CERTIFICATE/GetStudentDetailsBasedOnDocumentTypeStudentId/?academic_year_id=${academicYearId}&orgId=${orgId}&branchId=${branchId}&document_type=${documentType}&studentId=${studentId}`;

      const response = await fetch(apiUrl, { method: "GET" });

      if (!response.ok) {
        throw new Error("Failed to fetch student details.");
      }

      const result = await response.json();

      if (result.message === "success") {
        const routeState = {
          ...result.data,
          school_admission_no:
            result.data?.school_admission_no || admissionNoRef.current?.value || "",
          admission_no:
            result.data?.admission_no || admissionNoRef.current?.value || "",
          barcode: result.data?.barcode || barcodeRef.current?.value || "",
          studentname: result.data?.studentname || studentNameRef.current?.value || "",
          classId:
            result.data?.classId ||
            result.data?.class_last_studied ||
            admittedClass ||
            "",
          sectionId:
            result.data?.sectionId || result.data?.section_id || admittedSection || "",
        };

        switch (documentType) {
          case "TC":
            navigate("/transfercertificateform", { state: routeState });
            break;
          case "CC":
            navigate("/charactercertificate", { state: routeState });
            break;
          case "BC":
            navigate("/bonafidecertificate", { state: routeState });
            break;
          case "FC":
            navigate("/feecertificate", { state: routeState });
            break;
          default:
            alert("Invalid document type.");
            break;
        }
      } else {
        alert("Failed to fetch student details: " + result.message);
      }
    } catch (error) {
      console.error("Error fetching student details:", error);
      alert(
        "An error occurred while fetching student details. Please try again."
      );
    }
  };

  useEffect(() => {
    const storedClassId = localStorage.getItem("selectedCertificateClassId");
    const storedSectionId = localStorage.getItem(
      "selectedCertificateSectionId"
    );

    if (storedClassId) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        classId: storedClassId,
      }));
    }

    if (storedSectionId) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        sectionId: storedSectionId,
      }));
    }
  }, [showStudentSelectionModal]);

  const documentTypeMapping = {
    TC: "Transfer Certificate",
    CC: "Character Certificate",
    BC: "Bonified Certificate",
    FC: "Fee Certificate",
  };

  // const handleSearch = () => {
  //   const academicYearId = localStorage.getItem("academicSessionId");
  //   const branchId = localStorage.getItem("branchId");
  //   const orgId = localStorage.getItem("orgId");
  //   const studentId = localStorage.getItem("selectedCertificateStudentId");
  //   const classId = localStorage.getItem("selectedCertificateClassId");
  //   const sectionId = localStorage.getItem("selectedCertificateSectionId");
  //   const documentType = localStorage.getItem("selectedDocumentType");
  //   const status = localStorage.getItem("status");

  //   const fromDate = dateFromRef.current.value;
  //   const toDate = dateToRef.current.value;

  //   const apiUrl = `${ApiUrl.apiurl}STUDENT_CERTIFICATE/GetStudentCertificates/`;
  //   const queryParams = new URLSearchParams({
  //     academic_year_id: academicYearId,
  //     orgId: orgId,
  //     branchId: branchId,
  //     studentId: studentId || "",
  //     classId: classId || "",
  //     sectionId: sectionId || "",
  //     DocumentType: documentType || "",
  //     status: status || "",
  //     FromDate: fromDate,
  //     ToDate: toDate,
  //   });

  //   // Fetch data from the API
  //   fetch(`${apiUrl}?${queryParams}`)
  //     .then((response) => response.json())
  //     .then((data) => {
  //       if (data.message === "success") {
  //         setCertificates(data.data);
  //       } else {
  //         console.error("Failed to fetch certificates data.");
  //       }
  //       setLoading(false);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching data:", error);
  //       setLoading(false);
  //     });
  // };

  //New code 08042025
  const handleSearch = useCallback(() => {
    const academicYearId = localStorage.getItem("academicSessionId");
    const branchId = localStorage.getItem("branchId");
    const orgId = localStorage.getItem("orgId");
    const studentId = localStorage.getItem("selectedCertificateStudentId");
    const classId = localStorage.getItem("selectedCertificateClassId");
    const sectionId = localStorage.getItem("selectedCertificateSectionId");
    const documentType = localStorage.getItem("selectedDocumentType");
    const status = localStorage.getItem("status");

    const fromDate = dateFromRef.current.value;
    const toDate = dateToRef.current.value;

    const apiUrl = `${ApiUrl.apiurl}STUDENT_CERTIFICATE/GetStudentCertificates/`;
    const queryParams = new URLSearchParams({
      academic_year_id: academicYearId,
      orgId: orgId,
      branchId: branchId,
      studentId: studentId || "",
      classId: classId || "",
      sectionId: sectionId || "",
      DocumentType: documentType || "",
      status: status || "",
      FromDate: fromDate,
      ToDate: toDate,
    });

    setLoading(true); // Optional: show spinner during fetch

    fetch(`${apiUrl}?${queryParams}`)
      .then((response) => response.json())
      .then((data) => {
        if (data.message === "success" && Array.isArray(data.data) && data.data.length > 0) {
          setCertificates(data.data);
          setMessage(""); // clear old messages
          setCurrentPage(0);
        } else {
          setCertificates([]); // clear table
          setMessage(data.message || "No data available.");
          setCurrentPage(0);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setCertificates([]);
        setMessage("An error occurred while fetching data.");
        setCurrentPage(0);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    handleSearch();
  }, [handleSearch, location.key]);

  const handleButtonClick = async (certificate, action) => {
    const certificateId = getCertificateId(certificate);
    const documentType = getCertificateType(certificate);
    const studentId = certificate?.studentId || "";

    localStorage.setItem("document_type", documentType);
    localStorage.setItem("documentType", documentType);
    localStorage.setItem("studentId", studentId);
    localStorage.setItem("transfer_certificate_id", certificateId);

    const academicYearId = localStorage.getItem("academicSessionId");
    const orgId = localStorage.getItem("orgId");
    const branchId = localStorage.getItem("branchId");

    const apiUrl = `${ApiUrl.apiurl}STUDENT_CERTIFICATE/GetStudentDetailsBasedOnDocumentTypeStudentId/?academic_year_id=${academicYearId}&orgId=${orgId}&branchId=${branchId}&document_type=${documentType}&studentId=${studentId}&transfer_certificate_id=${certificateId}`;

    try {
      const response = await fetch(apiUrl);
      const result = await response.json();

      if (action === "view") {
        navigate("/certificatepreview", {
          state: {
            certificate: result.data,
            documentType,
          },
        });
        return;
      }

      switch (documentType) {
        case "TC":
          navigate("/transfercertificateform", {
            state: result.data,
          });
          break;
        case "CC":
          navigate("/charactercertificate", {
            state: result.data,
          });
          break;
        case "BC":
          navigate("/bonafidecertificate", {
            state: result.data,
          });
          break;
        case "FC":
          navigate("/feecertificate", {
            state: result.data,
          });
          break;
        default:
          alert("Invalid document type.");
          break;
      }
    } catch (error) {
      console.error("Error fetching student details:", error);
    }
  };

  const handleExportToExcel = async () => {
    try {
      // Retrieve values from localStorage
      const academicYearId = localStorage.getItem("academicSessionId");
      const orgId = localStorage.getItem("orgId");
      const branchId = localStorage.getItem("branchId");

      // API URL
      const apiUrl = `${ApiUrl.apiurl}STUDENT_CERTIFICATE/GetStudentCertificates/?academic_year_id=${academicYearId}&orgId=${orgId}&branchId=${branchId}`;

      // Fetch API data
      const response = await fetch(apiUrl);
      const result = await response.json();

      if (result.message !== "success") {
        throw new Error("Failed to fetch data");
      }

      const data = result.data;

      // Map documentType and status codes
      const documentTypeMap = {
        TC: "Transfer Certificate",
        BC: "Bonafide Certificate",
        CC: "Character Certificate",
        FC: "Fee Certificate",
      };

      const statusMap = {
        C: "Canceled",
        A: "Approved",
        N: "New",
      };

      // Prepare data for Excel
      const excelData = data.map((item, index) => ({
        "Sr.No": index + 1,
        "Document Type": documentTypeMap[item.documentType] || "Unknown",
        "Applied On": item.tc_applied_date,
        "Issued On": item.tc_issued_date || "Not Issued",
        "Document No": item.transfer_certificate_no,
        "Student Name": item.studentname,
        Class: item.classname,
        Section: item.sectionname,
        Reason: item.reason_for_tc || "N/A",
        Status: statusMap[item.status] || "Unknown",
      }));

      // Create a new workbook and worksheet
      const worksheet = XLSX.utils.json_to_sheet(excelData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Certificates");

      // Write the Excel file and trigger download
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const blob = new Blob([excelBuffer], {
        type: "application/octet-stream",
      });
      saveAs(blob, "StudentCertificates.xlsx");
    } catch (error) {
      console.error("Error exporting to Excel:", error);
      alert("Failed to export data. Please try again.");
    }
  };

  // Pagination logic
  const offset = currentPage * itemsPerPage;
  const currentPageData = certificates.slice(offset, offset + itemsPerPage);
  const pageCount = Math.ceil(certificates.length / itemsPerPage);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  return (
    <div className="container-fluid ">
      <div className="row">
        <div className="col-12">
          <div className="card p-0">
            <div className="card-body">
              <p
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                STUDENT CERTIFICATE SEARCH
              </p>
              <div className="row  mb-3 mt-3 mx-0">
                <div
                  className="col-12  d-flex
                      flex-wrap
                      gap-2"
                >
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleNewButtonClick}
                  >
                    New
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleSearch}
                  >
                    Search
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleClear}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={() => navigate("/admin/dashboard")}
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleExportToExcel}
                  >
                    Export to Excel
                  </button>
                </div>
              </div>
              <div className="row mt-3 mx-2 custom-section-box">
                <div className="col-12 ">
                  <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                    <div className="row flex-grow-1 mb-3  mt-3">
                      <div className="col-12 col-md-3  ">
                        <label htmlFor="student-name" className="form-label">
                          Student Name<span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            id="student-name"
                            className="form-control detail"
                            placeholder="Enter student name"
                            ref={studentNameRef}
                            disabled
                          />

                          <button
                            type="button"
                            className="btn btn-primary ms-2 mb-0 mt-0"
                            onClick={() => setShowStudentSelectionModal(true)}
                            style={{ width: "50px", padding: "3px" }}
                          >
                            ...
                          </button>
                        </div>
                      </div>

                      <ModalCertificate
                        show={showStudentSelectionModal}
                        handleClose={handleModalClose}
                        onSelectStudent={(student) => {
                          const studentDetails = student.studentBasicDetails;
                          const selectedStudentName = getSelectedStudentName(studentDetails);
                          const selectedClassId =
                            studentDetails.addmitted_class ||
                            localStorage.getItem("selectedCertificateClassId") ||
                            "";
                          const selectedSectionId =
                            studentDetails.addmitted_section ||
                            localStorage.getItem("selectedCertificateSectionId") ||
                            "";

                          admissionNoRef.current.value =
                            studentDetails.admission_no;
                          barcodeRef.current.value = studentDetails.barcode;
                          studentNameRef.current.value = selectedStudentName;

                          setFormData((prev) => ({
                            ...prev,
                            school_admission_no: studentDetails.admission_no || "",
                            admission_no: studentDetails.admission_no || "",
                            barcode: studentDetails.barcode || "",
                            studentname: selectedStudentName,
                            classId: selectedClassId,
                            sectionId: selectedSectionId,
                          }));

                          handleModalClose();
                        }}
                      />

                      <div className="col-12 col-md-3 mb-1">
                        <label htmlFor="admission-no" className="form-label">
                          {" "}
                          Admission No <span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            id="admission-no"
                            className="form-control detail"
                            placeholder="Enter admission no"
                            ref={admissionNoRef}
                            disabled
                          />
                        </div>
                      </div>

                      <div className="col-12 col-md-3 mb-1">
                        <label htmlFor="student-barcode" className="form-label">
                          Student BarCode<span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            id="student-barcode"
                            className="form-control detail"
                            placeholder="Enter student BarCode"
                            ref={barcodeRef}
                            disabled
                          />
                        </div>
                      </div>

                      <div className="col-12 col-md-3 mb-2">
                        <label htmlFor="admitted-class" className="form-label">
                          Class<span style={{ color: "red" }}>*</span>
                        </label>
                        <Select
                          id="admitted-class"
                          className="detail"
                          classNamePrefix="react-select"
                          options={classes.map((classItem) => ({
                            value: classItem.id,
                            label: classItem.classname,
                          }))}
                          value={
                            classes
                              .map((classItem) => ({
                                value: classItem.id,
                                label: classItem.classname,
                              }))
                              .find(
                                (option) => option.value === formData.classId
                              ) || null
                          }
                          onChange={(selectedOption) =>
                            handleClassChange({
                              target: { value: selectedOption?.value },
                            })
                          }
                          placeholder="Select Class"
                          required
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                    <div className="row flex-grow-1">
                      {/* Admitted Section */}
                      <div className="col-12 col-md-3 mb-2">
                        <label
                          htmlFor="admitted-section"
                          className="form-label"
                        >
                          Section
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <Select
                          id="admitted-section"
                          className="detail"
                          classNamePrefix="react-select"
                          options={sections.map((section) => ({
                            value: section.section_id,
                            label: section.sectionname,
                          }))}
                          value={
                            sections
                              .map((section) => ({
                                value: section.section_id,
                                label: section.sectionname,
                              }))
                              .find(
                                (option) => option.value === formData.sectionId
                              ) || null
                          }
                          onChange={(selectedOption) =>
                            handleSectionChange({
                              target: { value: selectedOption?.value },
                            })
                          }
                          placeholder="Select Section"
                          required
                        />
                      </div>

                      {/* Status */}
                      <div className="col-12 col-md-3 mb-2">
                        <label htmlFor="status" className="form-label">
                          Status
                        </label>
                        <Select
                          id="status"
                          className="detail"
                          classNamePrefix="react-select"
                          options={[
                            { value: "New", label: "New" },
                            { value: "Approved", label: "Approved" },
                            { value: "Cancelled", label: "Cancelled" },
                          ]}
                          value={selectedStatus}
                          onChange={(selectedOption) => {
                            setSelectedStatus(selectedOption);

                            const statusValue = selectedOption?.value || "";
                            const statusMapping = {
                              New: "N",
                              Approved: "A",
                              Cancelled: "C",
                            };

                            if (statusValue) {
                              localStorage.setItem(
                                "status",
                                statusMapping[statusValue] || ""
                              );
                            } else {
                              localStorage.removeItem("status");
                            }
                          }}
                          placeholder="Select"
                        />
                      </div>

                      {/* Document Type */}
                      <div className="col-12 col-md-3 mb-2">
                        <label htmlFor="document-type" className="form-label">
                          Document Type <span style={{ color: "red" }}>*</span>
                        </label>
                        <Select
                          id="document-type"
                          className="detail"
                          classNamePrefix="react-select"
                          options={[
                            { value: "TC", label: "Transfer Certificate" },
                            { value: "CC", label: "Character Certificate" },
                            { value: "BC", label: "Bonafide Certificate" },
                            { value: "FC", label: "Fee Certificate" },
                          ]}
                          value={selectedDocumentType}
                          onChange={(selectedOption) => {
                            setSelectedDocumentType(selectedOption);
                            handleSelectChange({
                              target: { value: selectedOption?.value },
                            });
                          }}
                          placeholder="Select"
                        />
                      </div>

                      {/* Date From */}
                      <div
                        className="mb-2 me-md-2"
                        style={{ width: "100%", maxWidth: "150px" }}
                      >
                        <label htmlFor="date-from" className="form-label">
                          Date From
                        </label>
                        <input
                          type="date"
                          id="date-from"
                          className="form-control detail"
                          ref={dateFromRef}
                          defaultValue={todayDate}
                        />
                      </div>
                      {/* Date To */}
                      <div
                        className="mb-3 me-md-2"
                        style={{ width: "100%", maxWidth: "150px" }}
                      >
                        <label htmlFor="date-to" className="form-label">
                          Date To
                        </label>
                        <input
                          type="date"
                          id="date-to"
                          className="form-control detail"
                          ref={dateToRef}
                          defaultValue={todayDate}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="table-responsive">
                  <table className="table table-bordered table-striped">
                    <thead>
                      <tr>
                        <th>Sl.No</th>
                        <th>Document Type</th>
                        <th>Applied On</th>
                        <th>Issued On</th>
                        <th>Document No</th>
                        <th>Student Name</th>
                        <th>Class</th>
                        <th>Section</th>
                        <th>Reason</th>
                        <th>Status</th>
                        <th>Action</th>
                        <th>View</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="13" className="text-center">
                            Loading...
                          </td>
                        </tr>
                      ) : certificates.length > 0 ? (
                        currentPageData.map((certificate, index) => (
                          <tr key={getCertificateId(certificate) || index}>
                            <td>{offset + index + 1}</td>
                            <td>
                              {documentTypeMapping[getCertificateType(certificate)] ||
                                getCertificateType(certificate)}
                            </td>
                            <td>{formatDisplayDate(certificate.tc_applied_date)}</td>
                            <td>{formatDisplayDate(certificate.tc_issued_date)}</td>
                            <td>
                              {certificate.transfer_certificate_no_prefix &&
                                certificate.transfer_certificate_no_postfix
                                ? `${certificate.transfer_certificate_no_prefix}/${certificate.transfer_certificate_no_postfix}`
                                : "N/A"}
                            </td>
                            <td>{certificate.studentname}</td>
                            <td>{certificate.classname}</td>
                            <td>{certificate.sectionname}</td>
                            <td>{certificate.reason_for_tc || ""}</td>
                            <td>
                              {certificate.status === "A" && "Approved"}
                              {certificate.status === "C" && "Cancelled"}
                              {certificate.status === "N" && "New"}
                            </td>
                            <td>
                              {certificate.status === "C" ? (
                                <span className="text-muted">Not Editable</span>
                              ) : (
                                <button
                                  className="btn btn-sm btn-primary d-flex align-items-center"
                                  onClick={() => handleButtonClick(certificate, "edit")}
                                >
                                  <i className="fas fa-edit me-2"></i>
                                  Edit
                                </button>
                              )}
                            </td>
                            <td>
                              <button
                                className="btn btn-sm btn-secondary d-flex align-items-center"
                                onClick={() => handleButtonClick(certificate, "view")}
                              >
                                <i className="fas fa-eye me-2"></i>
                                View
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="13" className="text-center text-muted">
                            {message || "No records found."}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  <ReactPaginate
                    previousLabel={"Previous"}
                    nextLabel={"Next"}
                    breakLabel={"..."}
                    pageCount={pageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={3}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination justify-content-center mt-3"}
                    pageClassName={"page-item"}
                    pageLinkClassName={"page-link"}
                    previousClassName={"page-item"}
                    previousLinkClassName={"page-link"}
                    nextClassName={"page-item"}
                    nextLinkClassName={"page-link"}
                    breakClassName={"page-item"}
                    breakLinkClassName={"page-link"}
                    activeClassName={"active"}
                  />
                </div>
              </div>
            </div>{" "}
          </div>{" "}
        </div>{" "}
      </div>{" "}
    </div>
  );
};
export default AdmAttendanceEntry;
